/**
 * Whether two clip URLs point at the same underlying media object. Presigned S3 URLs are
 * re-minted on every fetch — identical origin and path, fresh `X-Amz-*` querystring — so a plain
 * string comparison would treat every re-sign as a new video and reload the player mid-playback.
 * Falls back to strict equality when either side does not parse as a URL.
 */
export const isSameClipUrl = (
  a: string | null | undefined,
  b: string | null | undefined
): boolean => {
  if (!a || !b) {
    return a === b
  }
  try {
    const urlA = new URL(a)
    const urlB = new URL(b)
    return urlA.origin === urlB.origin && urlA.pathname === urlB.pathname
  } catch {
    return a === b
  }
}
